const LogOutGoogleIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.66667 10.3322L13 6.9989M13 6.9989L9.66667 3.66557M13 6.9989H5M7 10.3322C7 10.5293 7 10.6278 6.99268 10.7132C6.91655 11.6002 6.26324 12.3301 5.39002 12.5038C5.30602 12.5205 5.20801 12.5313 5.01223 12.5531L4.3313 12.6288C3.30832 12.7424 2.7968 12.7993 2.39044 12.6692C1.84862 12.4958 1.40628 12.0999 1.17412 11.5806C1 11.191 1 10.6764 1 9.64711V4.3507C1 3.32141 1 2.80677 1.17412 2.41725C1.40628 1.89789 1.84862 1.50197 2.39044 1.32859C2.79681 1.19855 3.3083 1.25538 4.33129 1.36905L5.01223 1.44471C5.20808 1.46647 5.306 1.47735 5.39002 1.49405C6.26324 1.66767 6.91655 2.3976 6.99268 3.28464C7 3.36999 7 3.46852 7 3.66557"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LogOutGoogleIcon;
